
import React, { useState } from 'react';
import Header from '../../components/feature/Header';
import KitchenOrders from './components/KitchenOrders';
import InventoryManagement from './components/InventoryManagement';
import RecipeBook from './components/RecipeBook';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';

export default function DapurPage() {
  const [activeTab, setActiveTab] = useState<'orders' | 'inventory' | 'recipes'>('orders');
  const [darkMode, setDarkMode] = useState(true);
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [showOrdersModal, setShowOrdersModal] = useState(false);

  const tabs = [
    {
      id: 'orders' as const,
      name: 'Antrian Pesanan',
      icon: 'ri-restaurant-line',
      color: 'red',
      description: 'Kelola pesanan masuk dari pelanggan'
    },
    {
      id: 'inventory' as const,
      name: 'Manajemen Stok',
      icon: 'ri-archive-line',
      color: 'yellow',
      description: 'Monitor dan kelola inventory bahan makanan'
    },
    {
      id: 'recipes' as const,
      name: 'Buku Resep',
      icon: 'ri-book-open-line',
      color: 'green',
      description: 'Koleksi resep menu TAKEYA Restaurant'
    }
  ];

  const handleInventoryClick = () => {
    setShowInventoryModal(true);
  };

  const handleOrdersClick = () => {
    setShowOrdersModal(true);
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br from-gray-900 to-black ${darkMode ? 'dark' : ''}`}>
      <Header darkMode={darkMode} setDarkMode={setDarkMode} />
      
      <div className="pt-20">
        {/* Page Header */}
        <div className="bg-gradient-to-r from-red-900/20 to-yellow-900/20 backdrop-blur-sm border-b border-red-500/20">
          <div className="max-w-7xl mx-auto px-6 py-8">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-black text-white mb-4" style={{ fontFamily: '"Noto Sans JP", serif' }}>
                Panel <span className="text-red-500">Dapur</span>
                <span className="block text-2xl text-yellow-400 mt-2">キッチンパネル</span>
              </h1>
              <div className="flex items-center justify-center space-x-4 mb-4">
                <div className="h-px w-20 bg-gradient-to-r from-transparent to-red-500"></div>
                <div className="text-yellow-400 text-lg font-bold" style={{ fontFamily: '"Orbitron", sans-serif' }}>
                  KITCHEN MANAGEMENT SYSTEM
                </div>
                <div className="h-px w-20 bg-gradient-to-l from-transparent to-red-500"></div>
              </div>
              <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                Sistem manajemen dapur terintegrasi untuk mengoptimalkan operasional dan kualitas layanan
              </p>
            </div>

            {/* Tab Navigation */}
            <div className="flex flex-col lg:flex-row justify-center gap-4">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => {
                    if (tab.id === 'inventory') {
                      handleInventoryClick();
                    } else if (tab.id === 'orders') {
                      handleOrdersClick();
                    } else {
                      setActiveTab(tab.id);
                    }
                  }}
                  className={`flex items-center space-x-4 px-8 py-4 rounded-2xl text-left transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeTab === tab.id
                      ? `bg-gradient-to-r ${
                          tab.color === 'red' ? 'from-red-600 to-red-700' :
                          tab.color === 'yellow' ? 'from-yellow-600 to-yellow-700' :
                          'from-green-600 to-green-700'
                        } text-white shadow-lg transform scale-105 border-2 ${
                          tab.color === 'red' ? 'border-red-400' :
                          tab.color === 'yellow' ? 'border-yellow-400' :
                          'border-green-400'
                        }`
                      : 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50 hover:text-white hover:scale-102 border-2 border-transparent'
                  }`}
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                    activeTab === tab.id
                      ? 'bg-white/20'
                      : 'bg-gray-700'
                  }`}>
                    <i className={`${tab.icon} text-2xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold">{tab.name}</h3>
                    <p className={`text-sm ${activeTab === tab.id ? 'text-white/80' : 'text-gray-400'}`}>
                      {tab.description}
                    </p>
                  </div>
                  {activeTab === tab.id && (
                    <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-6 py-8">
          {/* Quick Stats */}
          <div className="grid md:grid-cols-4 gap-6 mb-8">
            <div className="bg-gradient-to-br from-red-900/20 to-red-800/20 backdrop-blur-sm rounded-2xl border border-red-500/20 p-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center">
                  <i className="ri-restaurant-line text-white w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-red-400">12</div>
                  <div className="text-gray-300 text-sm">Pesanan Aktif</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-yellow-900/20 to-yellow-800/20 backdrop-blur-sm rounded-2xl border border-yellow-500/20 p-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-yellow-600 rounded-xl flex items-center justify-center">
                  <i className="ri-time-line text-white w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-yellow-400">8m</div>
                  <div className="text-gray-300 text-sm">Avg Cook Time</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-900/20 to-green-800/20 backdrop-blur-sm rounded-2xl border border-green-500/20 p-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center">
                  <i className="ri-check-line text-white w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-green-400">45</div>
                  <div className="text-gray-300 text-sm">Selesai Hari Ini</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-900/20 to-blue-800/20 backdrop-blur-sm rounded-2xl border border-blue-500/20 p-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                  <i className="ri-archive-line text-white w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-blue-400">87%</div>
                  <div className="text-gray-300 text-sm">Stok Tersedia</div>
                </div>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="bg-gradient-to-br from-gray-800/30 to-gray-900/30 backdrop-blur-sm rounded-3xl border border-gray-600/20 p-8">
            {activeTab === 'orders' && <KitchenOrders />}
            {activeTab === 'inventory' && <InventoryManagement />}
            {activeTab === 'recipes' && <RecipeBook />}
          </div>
        </main>

        {/* Floating Action Button */}
        <div className="fixed bottom-8 left-8 z-40">
          <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-full p-4 shadow-2xl border border-red-400/30">
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-white font-semibold text-sm">Dapur Online</span>
            </div>
          </div>
        </div>

        {/* Kitchen Orders Management Modal */}
        {showOrdersModal && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl border border-red-500/20 w-full max-w-7xl max-h-[95vh] overflow-hidden">
              {/* Modal Header */}
              <div className="bg-gradient-to-r from-red-900/30 to-orange-900/30 backdrop-blur-sm border-b border-red-500/20 p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center">
                      <i className="ri-restaurant-line text-white w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-white">Kelola Pesanan Dapur</h2>
                      <p className="text-red-400">Monitor dan proses pesanan masuk dari pelanggan</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowOrdersModal(false)}
                    className="w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-xl flex items-center justify-center transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-white w-5 h-5 flex items-center justify-center"></i>
                  </button>
                </div>
              </div>

              {/* Modal Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(95vh-120px)]">
                <KitchenOrders />
              </div>
            </div>
          </div>
        )}

        {/* Inventory Management Modal */}
        {showInventoryModal && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl border border-yellow-500/20 w-full max-w-7xl max-h-[95vh] overflow-hidden">
              {/* Modal Header */}
              <div className="bg-gradient-to-r from-yellow-900/30 to-orange-900/30 backdrop-blur-sm border-b border-yellow-500/20 p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-yellow-600 rounded-xl flex items-center justify-center">
                      <i className="ri-archive-line text-white w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-white">Manajemen Stok Dapur</h2>
                      <p className="text-yellow-400">Monitor dan kelola inventory bahan makanan TAKEYA Restaurant</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowInventoryModal(false)}
                    className="w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-xl flex items-center justify-center transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-white w-5 h-5 flex items-center justify-center"></i>
                  </button>
                </div>
              </div>

              {/* Modal Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(95vh-120px)]">
                <InventoryManagement />
              </div>
            </div>
          </div>
        )}
      </div>

      <WhatsAppFloat />
    </div>
  );
}
